/* eslint-disable no-nested-ternary,react/no-array-index-key */
import React from 'react';
import findLast from 'lodash.findlast';
import {Area, AreaChart, ResponsiveContainer} from 'recharts';
import {seasonsBacktestingToData, dataToOutcome} from './helpers';
import {ChartLoading} from './icons';
import './charts.scss';

const Charts = ({seasons}) => {
  if (!seasons) return <ChartLoading />;

  const data = dataToOutcome({data: seasonsBacktestingToData(seasons)});

  return (
    <div className="charts">
      <ResponsiveContainer height={100} width="100%">
        <AreaChart
          height={100}
          data={data}
          margin={{
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}
        >
          <defs>
            <linearGradient id="positiveValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4caf50" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#4caf50" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="negativeValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f44336" stopOpacity={0.15} />
              <stop offset="100%" stopColor="#f44336" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="guideline" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="grey" stopOpacity={0.4} />
              <stop offset="100%" stopColor="grey" stopOpacity={0} />
            </linearGradient>
          </defs>
          {seasons.reverse().map(season => {
            const isLastAboveZero =
              season && season.name && findLast(data, value => value[season.name])[season.name] > 0;
            const isActive = season.active;
            return (
              <Area
                key={season.name}
                type="monotone"
                dataKey={season.name}
                stroke={isActive ? (isLastAboveZero ? '#4CAF50' : '#F44336') : 'grey'}
                fillOpacity={1}
                fill={isActive ? (isLastAboveZero ? 'url(#positiveValue)' : 'url(#negativeValue)') : 'url(#guideline)'}
                strokeWidth={2}
                isAnimationActive={false}
              />
            );
          })}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Charts;
